export class InvoiceTransModel {
    tran_sequence: number;
    sup_sequence: number;
    client_no: number;
    pet_no: number;
    link_no: number;
    link_type: number;
    code_name: string;
    item_type: string;
    unit: number;
    req_date: string;
    appr_date: string;
    done_date: string;
    req_by: number;
    Req_employee_initial: string;
    done_by: number;
    employee_initial: string;
    appr_by: number;
    status: string;
    pstatus: boolean;
    tax: number;
    response1: string;
    response2: string;
    cost: number;
    route: string;
    printed: boolean;
    moved: boolean;
    code_clinic: number;
    location: string;

    constructor(
        tran_sequence: number,
        sup_sequence: number,
        client_no: number,
        pet_no: number,
        link_no: number,
        link_type: number,
        code_name: string,
        item_type: string,
        unit: number,
        req_date: string,
        appr_date: string,
        done_date: string,
        req_by: number,
        Req_employee_initial: string,
        done_by: number,
        employee_initial: string,
        appr_by: number,
        status: string,
        pstatus: boolean,
        tax: number,
        response1: string,
        response2: string,
        cost: number,
        route: string,
        printed: boolean,
        moved: boolean,
        code_clinic: number,
        location: string
    ) {
        this.tran_sequence = tran_sequence;
        this.sup_sequence = sup_sequence;
        this.client_no = client_no;
        this.pet_no = pet_no;
        this.link_no = link_no;
        this.link_type = link_type;
        this.code_name = code_name;
        this.item_type = item_type;
        this.unit = unit;
        this.req_date = req_date;
        this.appr_date = appr_date;
        this.done_date = done_date;
        this.req_by = req_by;
        this.Req_employee_initial = Req_employee_initial;
        this.done_by = done_by;
        this.employee_initial = employee_initial;
        this.appr_by = appr_by;
        this.status = status;
        this.pstatus = pstatus;
        this.tax = tax;
        this.response1 = response1;
        this.response2 = response2;
        this.cost = cost;
        this.route = route;
        this.printed = printed;
        this.moved = moved;
        this.code_clinic = code_clinic;
        this.location = location;
    }
}


export class TmpInvoiceTransModel {
    tran_sequence: number;
    sup_sequence: number;
    pet_no: number;
    client_no: number;
    link_no: number;
    link_type: number;
    unit: number;
    req_date: string;
    appr_date: string;
    done_date: string;
    req_by: number;
    appr_by: number;
    done_by: number;
    pstatus: boolean;
    response1: string;
    response2: string;
    cost: number;
    route: string;
    location: string;
    supervisor: string;
    status: string;

    constructor(
        tran_sequence: number,
        sup_sequence: number,
        pet_no: number,
        client_no: number,
        link_no: number,
        link_type: number,
        unit: number,
        req_date: string,
        appr_date: string,
        done_date: string,
        req_by: number,
        appr_by: number,
        done_by: number,
        pstatus: boolean,
        response1: string,
        response2: string,
        cost: number,
        route: string,
        location: string,
        supervisor: string,
        status: string
    ) {
        this.tran_sequence = tran_sequence;
        this.sup_sequence = sup_sequence;
        this.pet_no = pet_no;
        this.client_no = client_no;
        this.link_no = link_no;
        this.link_type = link_type;
        this.unit = unit;
        this.req_date = req_date;
        this.appr_date = appr_date;
        this.done_date = done_date;
        this.req_by = req_by;
        this.appr_by = appr_by;
        this.done_by = done_by;
        this.pstatus = pstatus;
        this.response1 = response1;
        this.response2 = response2;
        this.cost = cost;
        this.route = route;
        this.location = location;
        this.supervisor = supervisor;
        this.status = status;
    }
}
